import React from 'react';
import Helmet from 'react-helmet';

export default function SEO(props) {
	const { title, description, image, keywords, slug } = props;

	const url = `${process.env.GATSBY_WEBSITE_URL}${slug ? `${slug}` : ''}`;
	const imageUrl = `${image ? image : ''}`;
	const seoTitle = title
		? title
		: `${process.env.GATSBY_WEBSITE_NAME} Website `;
	const seoDescription = description
		? description
		: `${process.env.GATSBY_WEBSITE_NAME} `;
	const seoKeywords = keywords
		? keywords
		: `${process.env.GATSBY_WEBSITE_NAME},IT, Cybersecurity, Top Ten `;

	return (
		<Helmet
			htmlAttributes={{ lang: 'en' }}
			meta={[
				{
					name: 'description',
					content: seoDescription,
				},
				{
					name: 'keywords',
					content: seoKeywords,
				},
				{
					property: 'og:title',
					content: seoTitle,
				},
				{
					property: 'og:description',
					content: seoDescription,
				},
				{
					property: 'og:type',
					content: 'website',
				},
				{
					name: 'twitter:title',
					content: seoTitle,
				},
				{
					name: 'twitter:description',
					content: seoDescription,
				},
				{
					name: 'twitter:card',
					content: seoDescription,
				},
				{
					name: 'twitter:creator',
					content: `${process.env.GATSBY_WEBSITE_NAME}`,
				},
			].concat(
				image
					? [
							{
								name: 'image',
								property: 'og:image',
								content: imageUrl,
							},
							{
								property: 'og:image:width',
								content: '1200',
							},
							{
								property: 'og:image:height',
								content: '628',
							},
							{
								name: 'twitter:card',
								content: 'summary_large_image',
							},
					  ]
					: [
							{
								name: 'twitter:card',
								content: 'summary',
							},
					  ]
			)}
		>
			{/* General tags */}
			<title>{title}</title>
			<meta name='description' content={seoDescription} />
			<meta name='image' content={imageUrl} />
			<link rel='canonical' href={url} />

			{/* OpenGraph tags */}
			<meta property='og:url' content={url} />
			<meta property='og:type' content='website' />
			<meta property='og:title' content={seoTitle} />
			<meta property='og:description' content={seoDescription} />
			<meta property='og:image' content={imageUrl} />

			{/* Twitter Card tags */}
			<meta name='twitter:card' content='summary_large_image' />
			<meta name='twitter:title' content={seoTitle} />
			<meta name='twitter:description' content={seoDescription} />
			<meta name='twitter:image' content={imageUrl} />
		</Helmet>
	);
}
